export interface IComparisonNotification {
  text: string;
  category: EComparisonNotificationCategory;
  offerId: number;
  url?: string | null;
}

export enum EComparisonNotificationCategory {
  Add = 'add',
  Limit = 'limit',
  Remove = 'remove',
}

export interface IComparisonStatusInfo {
  description: string;
  status: EComparisonStatus;
}

export enum EComparisonStatus {
  Added = 'added',
  Available = 'available',
  Unavailable = 'unavailable',
}
